var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestFedExIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_705",
    "data-name": "Group 705",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.219,
    height: 29.89,
    viewBox: "0 0 30.219 29.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 30.219,
    height: 29.89,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M3.939,14.945H2.833A2.818,2.818,0,0,1,0,12.143V2.8A2.783,2.783,0,0,1,.83.821a2.849,2.849,0,0,1,2-.821H16.054a2.849,2.849,0,0,1,2,.821A2.786,2.786,0,0,1,18.887,2.8v.934H20.02a4.753,4.753,0,0,1,3.257,1.288l2.294,2.161A2.762,2.762,0,0,1,26.441,9.2v4.087a1.67,1.67,0,0,1-1.679,1.661H22.5a2.844,2.844,0,0,1-5.343,0H9.282a2.844,2.844,0,0,1-5.343,0ZM6.61,13.077a.934.934,0,1,1-.944.934A.94.94,0,0,1,6.61,13.077Zm13.221,0a.934.934,0,1,1-.944.934A.94.94,0,0,1,19.831,13.077Zm-5.666-5.6H4.722a.934.934,0,1,0,0,1.868h9.443a.934.934,0,1,0,0-1.868Zm0-2.8H6.61a.934.934,0,1,0,0,1.868h7.555a.934.934,0,1,0,0-1.868Z",
    transform: "translate(1.889 6.538)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestFedExIcon);
export default __webpack_public_path__ + "static/media/request-FedEx-icon.3ad7909241d511cef4e2161ad149233f.svg";
export { ForwardRef as ReactComponent };